<template>
    <!-- 量表题 -->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">量表题</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<template>
					<el-dropdown v-if="!$route.query.bankId" @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
						<span class="el-dropdown-link">
							<el-tooltip content="收藏到题库" placement="top" effect="light">
                                <i v-if="question.isedit && !question.bqid"  class="el-icon-star-off to-bank item"></i>
							</el-tooltip>
						</span>
						<el-dropdown-menu slot="dropdown">
							<div class="scroll-body" style="overflow-y: auto;" :style="{maxHeight: isAddBank ? '102px' : '200px'}">
							<el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
								<span>{{item.name}}</span>
								<el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
							</el-dropdown-item>
							<el-dropdown-item 
								disabled
								style="
								font-size: 12px;
								color: #ccc"
								class="dropdown-item" 
								v-if="bankList.length == 0">
								<span>暂无题库</span>
							</el-dropdown-item>
							</div>

							<el-dropdown-item v-if="isAddBank" divided style="text-align:center">
							<el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
								<el-form-item
								prop="name"
								:rules="[
									{ required: true, message: '不能为空'},
								]"
								>
								<el-input size="mini" v-model="bankForm.name"></el-input>
								</el-form-item>
								<el-form-item  size="mini" style="text-align: right;margin-bottom: 0;">
								<el-button type="text" @click="addBank">创建</el-button>
								<el-button  type="text" @click="cancelAddBank">取消</el-button>
								</el-form-item>
							</el-form>
							</el-dropdown-item>
							
							<el-dropdown-item divided style="text-align:center">
							<el-button  @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tooltip content="取消收藏" placement="top" effect="light">
						<i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid"  @click="delFormBank"></i>
					</el-tooltip>
				</template>
				<template v-if="!isBankViewTest">
					<div @click="() => $emit('jumpshow', question)">
						<el-badge 
							v-if="question.logicalSettings.num" 
							:value="question.logicalSettings.num" 
							class="item">
							<i class="el-icon-share"  ></i>
						</el-badge>
					</div>
					<i  class="el-icon-rank item drag-handle"></i>
					<i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyClick(question)"></i>
					<i class="el-icon-delete delete" v-if="question.isedit" @click="questiondel(question.qid)"></i>
				</template>
			</el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;">
            <div >
                <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20"
                        class="el_item_option item_container_title" style="margin-left:50px">
                    <div class="inputvalue">
                        <div class="option-box">
                            <template v-if="question.displayStyle !== 0">
                                <img 
                                    class="option-img"
                                    v-for="(item, index) in question.orderSetting"
                                    :key="index"
                                    :src="rateDataList[question.displayStyle].checkedImg" 
                                    alt=""
                                >
                            </template>
                            <template v-else>
                                <el-radio
                                    v-for="(item, index) in question.orderSetting"
                                    :key="index" 
                                    v-model="value" 
                                    :label='question.startNum + index'
                                >{{question.startNum + index}}</el-radio>
                            </template>
                        </div>
                        <div class="tips-box" >
                            <span>{{ question.leftText }}</span>
                            <span>{{ question.rightText }}</span>
                        </div>
                    </div>
                </el-col>
            </div>
        </el-row>
    </div>
</template>
<script>
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
	components: {
    	TitleEditor,
	},
        data() {
            return {
                value: 0,
                rateDataList: [
                    {
                        value: 'number',
                        id: 0
                    },
                    {
                        checkedImg:require('@/assets/rate/star_def.png'),
                        unCheckedImg: require('@/assets/rate/star_sel.png'), 
                        value: 'star',
                        id: 1
                    },
                    {
                        checkedImg:require('@/assets/rate/heart_def.png'),
                        unCheckedImg: require('@/assets/rate/heart_sel.png'),
                        value: 'heart',
                        id: 2
                    },
                    {
                        checkedImg:require('@/assets/rate/laugh_def.png'),
                        unCheckedImg: require('@/assets/rate/laugh_sel.png'),
                        value: 'smile',
                        id: 3
                    },
                    {
                        checkedImg:require('@/assets/rate/good_def.png'),
                        unCheckedImg: require('@/assets/rate/good_sel.png'),
                        value: 'thumb',
                        id: 4
                    }
                ],
                // 题库start
                isAddBank: false,
                bankForm: {
                    isSystemBank: 0, // 我的题库
                    name: '',
                    type: '未分类',
                    bankType: 1
                }
                // 题库end
            }
        },
        props: {
            question: {},
            editOptionIndex: {type:String,default:"0_0"},
            editIndex: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            index: {type:Number,default:0},
            tipsObj: {type: Object},
            imageUrl:{type:Object},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
            bankList: {
                type: Array,
                default: () => {
                return []
                }
            },
        },
        watch: {
            'question.questionsName':{
                handler(newV, oldV){
                    if (newV !== oldV && this.question.bqid) {
                        this.question.bqid = ''
                    }
                },
                deep: true
            },
        },
        methods: {
            copyClick(question){
            	this.$emit('questionCopy',question)
            },
            // 题库start
            getBankList(e) {
                if (e) {
                    this.$emit('getBankList')
                }
            },
            addToBank(id) {
                this.$refs.bankDropdown.hide()
                this.$emit('addToBank', this.question, id)
                console.log(this.question)
            },
            cancelAddBank() {
                this.isAddBank = false
                this.bankForm.name = ''
            },
            addBank() {
                this.$refs.ValidateForm.validate((valid) => {
                    if (valid) {
                        this.isAddBank = true
                        this.$emit('addBank', this.bankForm, this.question.qid)
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                    });
                // this.$refs.bankDropdown.show()
            },
            delFormBank() {
                this.$emit('delFormBank', this.question)
            },
            // 题库end
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            questiondel(id){
                this.$emit("questiondel",id);
            },
        },
    }
</script>

<style scoped lang="scss">
.inputvalue {
    .tips-box, .option-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .option-box .option-img{
        width: 24px;
        height: 22px;
    }
}
.askxh {
    line-height: 40px;
    text-align: right;
}
.item_container_title {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
</style>
